import { render, staticRenderFns } from "./EXOffers.vue?vue&type=template&id=6b4cc96e"
import script from "./EXOffers.vue?vue&type=script&lang=js"
export * from "./EXOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports